<template lang="pug">
.simple-mode-datatable
    v-data-table(
        hide-actions
        :items="items"
        :headers="headers"
        disable-initial-sort
        )
        template(slot="items" slot-scope="{item}")
            tr
                td(
                    v-for="header in headers"
                    :key="header.text"
                )
                    slot(
                        :name="header.text"
                        v-if="header.value === 'slot'"
                        v-bind:item="item"
                        )
                    span(v-else) {{item[header.value]}}
    .pagination-container.text-xs-center
        v-pagination(
            v-if="pagination && pagination.current_page && pagination.last_page > 1"
            v-model="pagination.current_page"
            :length="pagination.last_page"
        )
</template>

<script>
import { cloneDeep } from 'lodash'
export default {
    props: {
        model: {
            type: Object,
            required: true,
        },
        headers: {
            type: Array,
            default: () => [],
        },
    },
    data: () => ({ items: [], pagination: null }),
    computed: {
        currentPage() {
            return this.pagination && this.pagination.current_page
                ? this.pagination.current_page
                : null
        },
    },
    methods: {
        refresh(model) {
            let mdl = cloneDeep(model)
            if (this.currentPage) mdl = mdl.page(this.currentPage)
            this.$emit('isLoading', true)
            mdl.get()
                .then(r => {
                    this.items = r.data
                    this.pagination = {
                        from: r.from,
                        to: r.to,
                        total: r.total,
                        current_page: r.current_page,
                        last_page: r.last_page,
                    }
                })
                .catch(e => this.$emit('error', e))
                .finally(() => this.$emit('isLoading', false))
        },
    },
    watch: {
        model: {
            handler(v) {
                this.refresh(v)
            },
            immediate: true,
        },
        currentPage(val, oldVal) {
            if (!val || !oldVal) return
            if (val === oldVal) return
            this.refresh(this.model)
        },
    },
}
</script>
